import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import SeasonSelect from "../SeasonSelect";
import {useTranslation} from "react-i18next";
import MDInput from "../../../materialDashboard/components/MDInput";
import MenuItem from "@mui/material/MenuItem";

export const useToolbar = ({availableSeasons, availableAttributes, initialSelectedAttribute}) => {
    const sortedSeason = availableSeasons.sort((a, b) => b - a);

    const [seasonFrom, setSeasonFrom] = useState(sortedSeason?.[0] ?? null)
    const [seasonTo, setSeasonTo] = useState(null);
    const [selectedAttribute, setSelectedAttribute] = useState(initialSelectedAttribute ?? availableAttributes?.[0]?.value ?? null);
    const [type, setType] = useState("bar");

    useEffect(() => {
        setSeasonFrom(sortedSeason?.[0] ?? null);
        setSeasonTo(null);
    }, [availableSeasons]);

    return {
        seasonFrom,
        setSeasonFrom,
        seasonTo,
        setSeasonTo,
        availableSeasons,
        selectedAttribute,
        setSelectedAttribute,
        availableAttributes,
        type,
        setType
    }
}

const Toolbar = (props) => {
    const {t} = useTranslation("graphs");
    const {
        seasonFrom,
        setSeasonFrom,
        seasonTo,
        setSeasonTo,
        availableSeasons,
        selectedAttribute,
        setSelectedAttribute,
        availableAttributes,
        type,
        setType
    } = props;

    const handleAttributeChange = (event) => {
        const value = event.target.value;
        setSelectedAttribute(value);
    }

    return <Grid container sx={{py: 4}} columnSpacing={2}>
        <Grid item xs={12} lg={3}>
            <MDInput label={t("toolbar.attributeLabel")}
                     value={selectedAttribute ?? ""}
                     onChange={handleAttributeChange}
                     variant="standard"
                     select
                     fullWidth>
                {
                    availableAttributes.map(attribute => (
                        <MenuItem key={attribute.label} value={attribute.value}>{attribute.label}</MenuItem>
                    ))
                }
            </MDInput>
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={seasonFrom}
                          setSelectedSeason={setSeasonFrom}
                          sx={{minWidth: "9rem"}}
                          label={t("toolbar.seasonFrom")}
                          availableSeasons={availableSeasons}
                          fullWidth
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={seasonTo}
                          setSelectedSeason={setSeasonTo}
                          sx={{minWidth: "9rem"}}
                          label={t("toolbar.seasonTo")}
                          availableSeasons={availableSeasons}
                          fullWidth
                          optionsFrom={seasonFrom}
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <MDInput label={t("toolbar.graphType.label")}
                     value={type}
                     onChange={(e) => setType(e.target.value)}
                     variant="standard"
                     select
                     fullWidth>
                <MenuItem value="bar">{t("toolbar.graphType.bar")}</MenuItem>
                <MenuItem value="pie">{t("toolbar.graphType.pie")}</MenuItem>
            </MDInput>
        </Grid>
    </Grid>
}

export default Toolbar;